import { useEffect } from 'react';

export const onRowEnter = (rowId: number | string) => {
	document.querySelectorAll(`[class$=row-${rowId}]`).forEach(el => {
		el.classList.add('hovered');
	});
};

export const onRowLeave = (rowId: number | string) => {
	document.querySelectorAll(`[class*=row-${rowId}]`).forEach(el => {
		el.classList.remove('hovered');
	});
};

const useRowHover = (ref: React.RefObject<HTMLDivElement>, rowId: number | string) => {
	useEffect(() => {
		const el = ref.current;

		const onMouseEnter = () => onRowEnter(rowId);
		const onMouseLeave = () => onRowLeave(rowId);

		if (el) {
			ref.current.addEventListener('mouseenter', onMouseEnter);
			ref.current.addEventListener('mouseleave', onMouseLeave);
		}

		return () => {
			el?.removeEventListener('mouseenter', onMouseEnter);
			el?.removeEventListener('mouseleave', onMouseLeave);
		};
	}, [ref, rowId]);
};

export default useRowHover;
